import React, { useEffect } from "react";

import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { resetState } from "../../redux-saga/redux/toast";

const Toast = () => {
  const { msg, tKey, success, error, target } = useSelector(
    (state) => state.toast
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (msg && success) {
      toast.success(msg, {
        id: msg
      });
    }
    if (msg && error) {
      toast.error(msg, {
        id: msg
      });
    }
    if (tKey && success) {
      toast.success(t(tKey), {
        id: tKey
      });
    }
    if (tKey && error) {
      toast.error(t(tKey), {
        id: tKey
      });
    }
    if (!tKey && !msg && error) {
      if (tKey !== "HEADER.SESSION_TIMEOUT") {
        toast.error(t("COMMON.ERROR"), {
          id: "COMMON.ERROR"
        });
      }
    }
    if (target) {
      navigate(target);
    }
    dispatch(resetState());
  }, [dispatch, msg, tKey, success, error, t, target, navigate]);

  return <></>;
};

export default Toast;
